/* Transient messages in the bottom-right corner. Ported verbatim from artifact.html. */

import { $ } from "./util.js";

export function toast(msg) {
  const el = document.createElement("div");
  el.className = "toast";
  el.textContent = msg;
  $("toasts").appendChild(el);
  setTimeout(() => el.remove(), 2600);
}
